// extracted by mini-css-extract-plugin
export var chip = "_2t-9";
export var chipLabel = "_2t-a";
export var close = "_2t-7";
export var closeIcon = "_2t-8";
export var error = "_2t-6";
export var infoTooltip = "_2t-2";
export var innerContainer = "_2t-1";
export var input = "_2t-b";
export var medium = "_2t-5";
export var outerContainer = "_2t-0";
export var small = "_2t-4";
export var xSmall = "_2t-3";